// Vuex & Store Entity Imports
import riskNotes from './riskNotesStore';

// TODO: replace with composables (0.5 days)
const risksStore = {
  namespaced: true,
  modules: {
    riskNotes,
  },
};

export default risksStore;
